module.exports = {
  selectLanguage: 'Язык',
  artistsPageButton: 'К списку архитекторов',
  mainPageButton: 'На главную',
  AuthorOfDay: 'Автор дня',
  footerMessage: 'Сайт разработан',
  timelineTitle: 'Линия времени',
  worksTitle: 'Главные произведения',
  videoTitle: 'Youtube видео',
  mapTitle: 'Карта',
  galleryTitle: 'Галерея',
  logo: 'Архитекторы Беларуси',
  be: 'Беларуская',
  ru: 'Русский',
  en: 'English',
  notFound: 'Страница не найдена',
  artistCardReadMore: 'ЧИТАТЬ ДАЛЬШЕ',
  aboutPortal: 'О Портале',
  aboutPortalText1: 'Активная архитектурно-строительная деятельность в Беларуси началась в конце 1920-х годов. До этого времени основные работы сводились к восстановлению, приспособлению и реконструкции существовавших зданий.Задачи, стоявшие перед страной, потребовали консолидации всех творческих сил республики.В 1932 году был создан комитет по объединению  советских архитекторов. Архитекторы–члены Союза архитекторов БССР участвовали в реконструкции и строительстве городов и сел Белоруссии, становлении белорусской советской архитектуры.',
  aboutPortalText2: 'На этом портале вы можете познакомиться с этими выдающимися архитекторами, а также можете найти информацию о наших соотечественниках, которые оставили значительный след в развитии архитектуры Беларуси. Здесь собраны их биографии с интересными фактами, фотогалерея их работ, видеоролики, связанные с их деятельностью или эпохой, в которой они жили, и многое другое.',
  ourTeam: 'Наша Команда',
  searchPlaceholder: 'Поиск',
  noSearchResults: 'Ничего не найдено',
  showVideo: 'Смотреть видео',
  contribMiatlionak: 'управление проектом, архитектура проекта,создание нескольких компонентов, исправление ошибок',
  contribHantarenka: 'создание нескольких компонентов, исправление ошибок, стилизация компонентов',
  contribPranovich: 'макет страницы,создание нескольких компонентов, стилизация компонентов',
  contribKlempach: ' многоязычность, наполнение данных в Contentful CMS, исправление ошибок',
  contribShynkarou: 'виджет поиска, проектная документация',
  contribKaptsevich: 'компонент "Список работ автора", компонент "Автор дня"',
  contribDucatuslt: 'навигация по странице автора',
};
